package modysy.menu

import modysy.InputHandler
import modysy.datastructures.Vector2
import modysy.view.Color
import org.scalajs.dom.CanvasRenderingContext2D
import org.scalajs.dom.raw.TextMetrics

/**
  *
  * An AbstractButton in the form of a rectangle
  * Can Optionally Display a text
  *
  * Attributes that can be set later on:
  *
  * textDisplayed text the button shows
  * font font of the text
  * fontSize font-size of the text
  * colorEdges color the text and the edges will be displayed in
  * colorBackground color the background will be displayed in
  * colorBackgroundSelected color the background will be displayed in if the mouse is pointing on the button
  *
  * @param x x-Position of button on canvas
  * @param y y-Position of button on canvas
  *
  */
class RectangleButton(x: Double, y: Double, width: Double, height: Double)
    extends AbstractButton(x, y) {

  var textDisplayed: String = ""
  var font: String = "Arial"
  var colorEdges: String = Color.White
  var colorEdgesSelected: String = Color.Black
  var colorBackground: String = Color.Transparent
  var colorBackgroundSelected: String = Color.Red

  private val left_border = x - width / 2
  private val right_border = x + width / 2
  private val upper_border = y - height / 2
  private val lower_border = y + height / 2

  /**
    * Displays the Button
    *
    * @param ctx The CanvasRenderingContext2D of the canvas
    */
  override def render(ctx: CanvasRenderingContext2D): Unit = {

    ctx.fillStyle =
      if (_mousePointing || fingerPointing) colorBackgroundSelected
      else colorBackground
    ctx.fillRect(x - width / 2, y - height / 2, width, height)

    ctx.strokeStyle =
      if (_mousePointing || fingerPointing) colorEdgesSelected else colorEdges
    ctx.strokeRect(x - width / 2, y - height / 2, width, height)
    //ctx.fill()

    ctx.fillStyle =
      if (_mousePointing || fingerPointing) colorEdgesSelected else colorEdges
    ctx.textBaseline = "middle"
    ctx.font = height / 2 + "px " + this.font
    ctx.textAlign = "center"
    ctx.fillText(textDisplayed, x, y, Integer.MAX_VALUE)

    ctx.textBaseline = "alphabetic"
  }

  override def pointOnButton(point: Vector2): Boolean = {
    point.x > left_border && point.x < right_border && point.y < lower_border && point.y > upper_border
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/menu/RectangleButton.scala